export enum SERVICE_STATUS {
  /**
   * 成功
   */
  SUCCESS = '200000',

  /**
   * 未登录
   */
  NOT_AUTH = '200400'
}